import type { ComponentProps } from "react";

import { Text } from "@/components/ui/text";

/**
 * Text that shows a native browser tooltip on web, matching truncated content.
 */
export function TextWithToolTip({
    children,
    ...rest
}: ComponentProps<typeof Text>) {
    const title = typeof children === "string" ? children : undefined;
    return (
        <div title={title} style={{ display: "contents" }}>
            <Text {...rest}>{children}</Text>
        </div>
    );
}
